import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
@Component({
  selector: 'inc-file-add',
  templateUrl: './file-add-component.html',
  styleUrls: ['./file-add-component.scss'],
})
export class FileAddComponent implements OnInit {
  @Input() files: File[];
  @Input() accept = 'Application/pdf';
  @Output() filesChange: EventEmitter<File[]> = new EventEmitter();

  @ViewChild('input') input: ElementRef;

  constructor() { }

  ngOnInit() { }

  onFileSelected(event: any): void {
    if (event.target.files[0] && !this.files.filter(file => file.name === event.target.files[0].name).length) {
      this.files.push(event.target.files[0]);
      this.filesChange.emit(this.files);
      this.input.nativeElement.value = '';
    }
  }

  discardFile(i: number): void {
    this.files.splice(i, 1);
  }
}
